import api from '../services/api';

interface ClusterConfigResponse {
  'api-base-url': string;
  'api-key': string;
}

/**
 * Gets the cluster configuration
 */
export const getClusterConfig = async (idToken: string, schema: string) => {
  return api<ClusterConfigResponse>('schemas/cluster-info', {
    headers: { authorization: `Bearer ${idToken}`, 'Myosh-Schema': `${schema}` },
  });
};
